import { Link } from '@tanstack/react-router';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { publicErrorMessage } from '../../public/auth-errors.js';
import { PUBLIC_FORM } from '../../public/classes.js';
import { PublicShell } from '../../public/PublicShell.js';
import { api } from '../../shared/api.js';
import { Button, buttonClasses } from '../../ui/Button.js';
import { Field, Input } from '../../ui/Field.js';
import { FormActions } from '../../ui/FormActions.js';
import { Alert } from '../../ui/States.js';

const BACK = { to: '/login', label: 'Connexion' };

/**
 * Mot de passe oublié. La réponse est identique que le compte existe ou non (pas de divulgation).
 */
export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const request = useMutation({ mutationFn: () => api('auth.passwordResetRequest', { body: { email } }) });

  if (request.isSuccess) {
    return (
      <PublicShell title="Vérifiez votre messagerie" back={BACK}>
        <Alert tone="success" title="Demande envoyée">
          Si un compte existe pour <strong className="break-words">{email}</strong>, un e-mail vient de partir avec un lien
          pour choisir un nouveau mot de passe. Le lien est valable une heure.
        </Alert>
        <p className="mt-4 text-sm leading-relaxed text-ink-3">
          Rien reçu après quelques minutes ? Regardez dans les courriers indésirables, puis refaites la demande.
        </p>
        <Link to="/login" className={buttonClasses({ variant: 'secondary', block: true, className: 'mt-6' })}>
          Retour à la connexion
        </Link>
      </PublicShell>
    );
  }

  const error = publicErrorMessage(request.error);
  return (
    <PublicShell
      title="Mot de passe oublié"
      back={BACK}
      intro="Indiquez l’e-mail de votre compte : vous recevrez un lien pour choisir un nouveau mot de passe."
    >
      <form
        className={PUBLIC_FORM}
        onSubmit={(e) => {
          e.preventDefault();
          request.mutate();
        }}
      >
        <Field label="E-mail">
          <Input
            type="email"
            name="email"
            autoComplete="username"
            inputMode="email"
            autoCapitalize="none"
            spellCheck={false}
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Field>
        {error ? (
          <Alert tone="danger" role="alert">
            {error}
          </Alert>
        ) : null}
        <FormActions>
          <Button type="submit" size="lg" block loading={request.isPending}>
            Recevoir le lien
          </Button>
        </FormActions>
      </form>
    </PublicShell>
  );
}
